import { takeLatest, put, call } from 'redux-saga/effects';
import * as corporateAction from './action';
import { CORE_API } from '../../config';
import { HTTP_HEADERS } from '../../constants';
import request from '../../components/Utils/httpHelper';

export function* globalCounterpartySearchSimple(action) {
    let requestUrl = `${CORE_API}/counterparty/search`;
    try {
        const listResult = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(corporateAction.globalCounterpartySearchSuccess(listResult));
    } catch (err) {
        yield put(corporateAction.globalCounterpartySearchFailure(err))
    }
}
export function* globalCounterpartySearch() {
    yield takeLatest(corporateAction.GLOBAL_COUNTERPARTY_SEARCH, globalCounterpartySearchSimple);
}

export function* globalCounterpartySearchAdvanced(action) {
    let requestUrl = `${CORE_API}/counterparty/search/${action.search}`;
    try {
        const listResult = yield call(request, requestUrl, { data: action.stateList, method: 'POST', headers: HTTP_HEADERS });
        yield put(corporateAction.advancedGlobalCounterpartySearchSuccess(listResult));
    } catch (err) {
        yield put(corporateAction.advancedGlobalCounterpartySearchFailure(err))
    }
}
export function* advancedGlobalCounterpartySearch() {
    yield takeLatest(corporateAction.ADVANCED_GLOBAL_COUNTERPARTY_SEARCH, globalCounterpartySearchAdvanced);
}

export function* counterpartyViewDetails(action) {

    let requestUrl = `${CORE_API}/counterparty/select/${action.id}`;
    try {
        const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(corporateAction.viewSelectedCounterpartySuccess(listResult.data));
    } catch (err) {
        yield put(corporateAction.viewSelectedCounterpartyFailure(err))
    }
}
export function* counterpartyView() {
    yield takeLatest(corporateAction.VIEW_SELECTED_COUNTERPARTY, counterpartyViewDetails);
}

export function* corporateColor(action) {

    let requestUrl = `${CORE_API}/corporate/whitelabel`;
    try {
        const listResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(corporateAction.setCorporateColorSuccess(listResult.data));
    } catch (err) {
        yield put(corporateAction.setCorporateColorFailure(err))
    }
}
export function* setCorporateColor() {
    yield takeLatest(corporateAction.SET_CORPORATE_COLOR, corporateColor);
}